module.exports = __webpack_public_path__ + "static/img/CR.b6de7a34.svg";